/** Allowed attachment category keys (must match DB constraint). */
export const ATTACHMENT_CATEGORY_IDS = ['engineering', 'financial', 'shop'];

export const ATTACHMENT_CATEGORY_LABELS = {
  engineering: 'Engineering',
  financial: 'Financial',
  shop: 'Shop',
};
